import { ApiService }    from '../../app-lite/api/api.service';
import { CodeTypeModel } from '../../app-lite/core/models/code-type';
import { JsonService }   from '../../app-lite/core/services/json.service';
import { VehicleModel }  from '../../app-lite/vehicles/models/vehicle';

export class BookingDiaryUnassignedJobCtrl implements ng.IComponentController, ng.IOnDestroy, ng.IOnInit {
  dragging   = false;
  index      : number;
  job        : any;
  selector   = '.unassigned-job';
  event      : any;
  vehicle    : VehicleModel;
  jobStatuses: Array<CodeTypeModel>;

  constructor (
    private $element   : ng.IRootElementService,
    private $state     : ng.ui.IStateService,
    private jsonApi    : JsonService,
    private workshopAPI: ApiService
  ) {}

  $onDestroy () {
    this.$element.find(this.selector)[0].removeEventListener('mousedown', this.handleMousedown.bind(this));
    this.$element.find(this.selector)[0].removeEventListener('mousemove', this.handleMousemove.bind(this));
  }

  $onInit () {
    this.$element.find(this.selector)
      .data('event', this.job);

    /**
       * in order to remove the alClick dependency (which is very old),
       * i have implemented a custom onClick functionality for unassigned
       * jobs. Instead of having an ng-click event on the element, the function
       * is passed to this directive to be handled. After the click (or drag)
       * is finished, check if it was a drag. If it was not and there IS a
       * onClick function , call it here.
       */
    this.$element.find(this.selector)[0].addEventListener('mousedown', this.handleMousedown.bind(this));
    this.$element.find(this.selector)[0].addEventListener('mousemove', this.handleMousemove.bind(this));

    this.workshopAPI.get('/event', this.job.event_id)
    .then(event => {
      this.event = event;

      if (this.event.vehicle_id) {
        this.workshopAPI.get('/vehicle', this.event.vehicle_id)
        .then(vehicle => {
          this.vehicle = vehicle;
        });
      }
    });
  }

  getVehicleDescription () : string {
    return this.vehicle
      ? this.jsonApi.stripEmpties([
        this.vehicle.color,
        this.vehicle.make,
        this.vehicle.model,
        this.vehicle.plate_number
      ], ' ') as string
      : '';
  }

  handleMousedown () : void {
    this.dragging = false;
  }

  handleMousemove () : void {
    this.dragging = true;
  }

  viewUnassignedJob () : void {
    if (!this.dragging) {
        this.$state.go('app.event', {
          customer_id             : this.job.customer_id,
          vehicle_id              : this.event.vehicle_id,
          id                      : this.job.event_id,
          event_item_id           : this.job.event_item_id,
          unassigned_event_time_id: this.job.id
        });
    }
  }

}
